export default __webpack_public_path__ + "static/media/nature.6550b754.svg";